import { useEffect } from 'react'

/**
 * Публичные GTM-страницы (лендинг, прогон, вход, оплата) всегда в светлой теме
 * Laplace GTM (`.theme-gtm` в styles.css) независимо от выбранной темы
 * приложения; при уходе прежняя тема восстанавливается. Внутри рабочего
 * пространства тему задаёт `useWorkspaceShellTheme()`, не этот хук.
 */
export function useGtmTheme() {
  useEffect(() => {
    const root = window.document.documentElement
    const hadDark = root.classList.contains('dark')
    const hadLight = root.classList.contains('light')

    root.classList.remove('dark')
    root.classList.add('light', 'theme-gtm')

    return () => {
      root.classList.remove('theme-gtm', 'dark', 'light')

      if (hadDark) {
        root.classList.add('dark')
      } else if (hadLight) {
        root.classList.add('light')
      }
    }
  }, [])
}
